import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=0dd6f43e&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0dd6f43e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6f43e",
  null
  
)

export default component.exports